import { observer } from "mobx-react-lite";
import type { CSSProperties } from "react";
import { useEffect, useMemo, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Input } from "antd";
import { HomeApi } from "./HomeApi";
import { globalModel } from "../../global/GlobalModel";
import { HomeModel } from "./HomeModel";
import type { RandomSpaceAccessPublicConfig } from "./HomeModel";
import { homePageBackgroundStyle } from "../../SiteConfig";
import { ShellTopBar } from "../shell/ShellTopBar";
import "./HomeStyle.css";

const HomePage = observer(() => {
  const model = useMemo(() => new HomeModel(), []);
  const navigate = useNavigate();
  const enterGenRef = useRef(0);
  const [randomAccess, setRandomAccess] = useState<RandomSpaceAccessPublicConfig>({
    enabled: false,
    candidates: [],
  });

  const goSpaceHome = (id: string) => {
    navigate(`/space/${id}/home`);
  };

  useEffect(() => {
    let cancelled = false;
    void (async () => {
      const config = await HomeApi.getRandomSpaceAccessConfig();
      if (!cancelled) {
        setRandomAccess(config);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  useEffect(() => {
    const v = model.spaceIdInput;
    if (!/^\d{8}$/.test(v)) {
      return;
    }
    const gen = ++enterGenRef.current;
    void (async () => {
      const exists = await HomeApi.checkSpaceExists(v);
      if (gen !== enterGenRef.current) {
        return;
      }
      if (!exists) {
        model.setEntranceError("您输入的空间ID不存在");
        return;
      }
      goSpaceHome(v);
    })();
  }, [model, model.spaceIdInput, navigate]);

  const showRandomEnter =
    randomAccess.enabled && randomAccess.candidates.length > 0;

  const handleRandomEnter = () => {
    const list = randomAccess.candidates;
    if (!list.length) {
      return;
    }
    const idx = Math.floor(Math.random() * list.length);
    model.setEntranceError(null);
    goSpaceHome(list[idx]!);
  };

  const starwall = `${process.env.PUBLIC_URL || ""}/starwall.png`;
  const brandWord = `${process.env.PUBLIC_URL || ""}/longfans.png`;

  return (
    <div
      className="home-root"
      style={
        {
          ...homePageBackgroundStyle(),
          "--home-starwall-image": `url(${starwall})`,
        } as CSSProperties
      }
    >
      <ShellTopBar variant="hero" onLoginClick={() => globalModel.openLoginModal()} />
      <div className="home-content-area">
        <div className="home-content-bg" aria-hidden />
        <div className="home-hero">
          <div className="home-form">
            <Input
              className="home-input longfans-rect"
              size="large"
              placeholder="输入8位数字空间ID"
              maxLength={8}
              value={model.spaceIdInput}
              onChange={(e) => model.setSpaceIdInput(e.target.value)}
              inputMode="numeric"
              autoComplete="off"
              autoFocus
              status={model.entranceError ? "error" : undefined}
            />
            {showRandomEnter && (
              <button type="button" className="home-random-enter" onClick={handleRandomEnter}>
                随机进入
              </button>
            )}
            {model.entranceError && (
              <p className="home-entrance-error" role="alert">
                {model.entranceError}
              </p>
            )}
          </div>
          <div className="home-brand-block">
            <img
              className="home-brand-img"
              src={brandWord}
              alt="LONGFANS"
              draggable={false}
            />
            <p className="home-brand-tagline">与远见者，长期同行。</p>
          </div>
        </div>
      </div>
    </div>
  );
});

export default HomePage;
